import messages from '../locales/pl_PL.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'pl-PL',
};
export default lang;
